import { call, put, select } from "redux-saga/effects";
import { reviewApi } from "@services/api";
import { getAllReviewsInstructorActions } from "../slices";
import { showFailureToast } from "@helpers";

function* getAllReviewsInstructorWorker({ payload }) {
  try {
    yield put(getAllReviewsInstructorActions.pending());
    const response = yield call(reviewApi.getAllReviewsInstructor, payload);
    yield put(getAllReviewsInstructorActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllReviewsInstructorActions.failure(error));
    // TODO: handle callback | onFailure
    yield call(showFailureToast, "Loading reviews failed!");
  }
}

function* getMoreReviewsInstructorWorker({ payload }) {
  try {
    const { CurrentPage = 0 } = yield select(
      (state) => state.review.getAllReviewsInstructor.pagination
    );
    const response = yield call(reviewApi.getAllReviewsInstructor, {
      ...payload,
      pageNumber: CurrentPage + 1,
    });
    yield put(getAllReviewsInstructorActions.getMoreSuccess(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllReviewsInstructorActions.failure(error));
    // TODO: handle callback | onFailure
    yield call(showFailureToast, "Loading reviews failed!");
  }
}

export { getAllReviewsInstructorWorker, getMoreReviewsInstructorWorker };
